/**
 * Reproduction cycle constants and read-model types (Phase 3).
 *
 * The gestation window constants are shared by sire resolution at calving
 * (breeding op must fall in [calvingDate − MAX, calvingDate − MIN]) and by
 * the expected-calving projection at pregnancy diagnosis.
 */
import { LivestockOperationType } from "./Common.js";
export const BOVINE_GESTATION_DAYS = 283;
/** Window bounds used for sire resolution and calving projection. */
export const GESTATION_MIN_DAYS = 250;
export const GESTATION_MAX_DAYS = 320;
/**
 * Operation types that only apply to female animals (the old AI-only rule,
 * generalized in Phase 3). Shared by backend validation (single, batch and
 * herd fan-out paths) and the frontend catalogs/target pickers, so no surface
 * can advertise an action the write path rejects.
 */
export const FEMALE_ONLY_OPERATION_TYPES = new Set([
    LivestockOperationType.ARTIFICIAL_INSEMINATION,
    LivestockOperationType.HEAT_DETECTION,
    LivestockOperationType.NATURAL_BREEDING,
    LivestockOperationType.PREGNANCY_DIAGNOSIS,
    LivestockOperationType.ABORTION,
    LivestockOperationType.CALVING,
]);
/**
 * Animal tag applied to calves created without a real tag at calving time
 * (their `tagId` is a server-generated provisional `PEND-…` value, since the
 * column is NOT NULL). Lets the UI badge/filter calves awaiting a real tag.
 */
export const PENDING_TAG = "pending-tag";
//# sourceMappingURL=Reproduction.js.map